<template>
  <div class="modal fade" tabindex="-1" role="dialog" id="update-portal-user-modal">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <form @submit.prevent="submit">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">
                &times;
              </span>
            </button>

            <h4 class="modal-title">
              Update Portal User
            </h4>
          </div>

          <div class="modal-body">
            <SelectFormGroup
                v-model="data.user_id"
                name="user"
                label="User"
                :options="userOptions"
                :error="(errors.user_id || [])[0]"
            />
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal">
              Close
            </button>

            <button type="submit" class="btn btn-black">
              <i class="fa fa-save"></i> Save
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import http from '@/http'
import notify from '@/notify'
import Errors from '@/mixins/Errors'
import SelectFormGroup from '@/vendor/forms/FormGroups/Block/Select'

export default {
  components: {SelectFormGroup},

  mixins: [Errors],

  props: {
    selected: {
      type: Array
    },

    users: {
      type: Array
    },
  },

  data() {
    return {
      data: {}
    }
  },

  mounted() {
    this.listenForClose()
  },

  computed: {
    userOptions() {
      return this.users.map(user => {
        return {
          value: user.id,
          label: user.attributes.full_name
        }
      })
    }
  },

  methods: {
    listenForClose() {
      $(this.$el).on('hidden.bs.modal', this.reset)
    },

    submit() {
      if (!this.data.user_id) {
        this.errors = {user_id: ["The user field is required"]}

        return
      }

      this.errors = {}

      Promise
          .all(this.selected.map(partnership => http.put('/api/v2/companies/' + partnership.attributes.company_id + '/portals/' + partnership.attributes.portal_id + '/user', {user_id: this.data.user_id}).catch(() => {
          })))
          .then(responses => {
            notify.success('The portal user was updated')

             this.$emit('updated',responses.map(response => response.data.data))

            $(this.$el).modal('hide')
          })
    },

    reset() {
      this.errors = {}

      this.data = {}
    }
  }
}
</script>
